import MailOutline from '@mui/icons-material/MailOutline';
import { Button } from '@mui/material';
import { EnhancedDialog } from 'components/enhanced/dialog/EnhancedDialog';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { TextFieldAdapter } from 'components/enhanced/form/adapters/text-inputs/TextFieldAdapter';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { tenantSettingsService } from 'shared/services';

interface ShowEmailTiketingParams {
  hasBeenSent?: boolean;
  equipment_id?: number;
  equipment_cc_email?: string;
  equipment_email?: string;
  warehouse_code?: string | null;
  warehouse_phone?: string | null;
  onSubmit: (text) => void;
}
function ShowEmailTiketingDialog({
  hasBeenSent,
  equipment_id,
  equipment_cc_email,
  equipment_email,
  warehouse_code,
  warehouse_phone,
  onSubmit
}: ShowEmailTiketingParams) {
  const translationPrefix = 'pages.tickets';
  const { t } = useTranslation();

  const [emailBody, setEmailBody] = useState<string>();
  const [emailCC, setEmailCC] = useState<string>();
  const [sendDialog, setSendDialog] = useState(false);

  useEffect(() => {
    tenantSettingsService.get(1).then((res) => {
      const defaultBody = res.ticketing_default_email_body || '';
      const warehouseLine = warehouse_phone
        ? `Telefono magazzino dello strumento: ${warehouse_phone}`
        : '';
      const bodyWithWarehouse = warehouseLine
        ? `${defaultBody}\n${warehouseLine}`.trim()
        : defaultBody;
      setEmailBody(bodyWithWarehouse);
      const emailCC = [res.cc_ticketing, equipment_cc_email]
        .filter(Boolean)
        .map((item) => item.replace(/;/g, ' '))
        .join(' ');
      setEmailCC(emailCC);
    });
  }, [equipment_id, warehouse_phone, warehouse_code]);

  const opensetSendDialog = () => {
    setSendDialog(true);
  };

  const closesetSendDialog = () => {
    setSendDialog(false);
  };

  const handleSubmit = (values) => {
    onSubmit(values);
    closesetSendDialog();
  };

  return (
    <>
      <Button variant="outlined" size="small" onClick={opensetSendDialog} disabled={hasBeenSent}>
        <MailOutline className="mr-2" />
        {hasBeenSent ? t(`${translationPrefix}.sent`) : t(`${translationPrefix}.send`)}
      </Button>
      <EnhancedDialog
        open={sendDialog}
        onClose={closesetSendDialog}
        title={t(`${translationPrefix}.show-email`)}
        submitLabel={t('actions.save', 'Salva')}
        cancelLabel={t('actions.reset', 'Annulla')}
        maxWidth="md"
        submitButtonProps={{
          type: 'submit',
          form: 'sendEmailTicketing'
        }}>
        <EnhancedForm
          onSubmit={handleSubmit}
          formId="sendEmailTicketing"
          hideControls
          autoStyleLayout
          columns={1}>
          <IdentityField
            name="email_recipient"
            component={TextFieldAdapter}
            label={t('global.recipient')}
            placeholder={t('global.recipient-placeholder')}
            initialValue={equipment_email ? equipment_email : ''}
            type="text"
          />
          <IdentityField
            name="email_cc"
            component={TextFieldAdapter}
            label={t('global.cc')}
            initialValue={emailCC ? emailCC : ''}
            type="text"
          />
          <IdentityField
            name="email_body"
            component={TextFieldAdapter}
            label={t('global.message')}
            placeholder={t('global.message-placeholder')}
            initialValue={emailBody ? emailBody : ''}
            type="text"
            multiline
            rows={4}
          />
        </EnhancedForm>
      </EnhancedDialog>
    </>
  );
}

export default ShowEmailTiketingDialog;
